import { navigateTo } from '@hotjar/webapp/utils/routing';

// This service is a work-around that lets us mock out the navigation functions in the angular tests
angular.module('hjSurveysModule').service('ReactNavigation', function () {
    this.navigate = function (route, data) {
        return navigateTo(route, data);
    };
});
